// const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3030/api";

// function getHeaders(token) {
//   return {
//     "Content-Type": "application/json",
//     ...(token ? { Authorization: `Bearer ${token}` } : {}),
//   };
// }

// // Safe fetch helper — prevents HTML parse error on 404/500
// async function safeFetch(url, options = {}) {
//   const res = await fetch(url, options);
//   if (!res.ok) {
//     const text = await res.text();
//     const msg = text.startsWith("<") // HTML error page
//       ? `API error ${res.status} at ${url}`
//       : text;
//     throw new Error(msg);
//   }
//   return res.json();
// }

// // ── GET all leave types ───────────────────────────────
// // GET /leave-types
// export async function getLeaveTypes(token) {
//   const data = await safeFetch(`${BASE_URL}/api/leave-types`, {
//     headers: getHeaders(token),
//   });
//   const list = Array.isArray(data) ? data : data.leaveTypes ?? data.data ?? [];
//   // Normalize field names — backend may use unit_type or unitType
//   return list.map(lt => ({
//     ...lt,
//     id:               lt.id,
//     name:             lt.name,
//     unit_type:        lt.unit_type ?? lt.unitType ?? "DAY",
//     is_active:        lt.is_active ?? lt.isActive ?? true,
//     is_deleted:       lt.is_deleted ?? lt.isDeleted ?? false,
//     requires_document: lt.requires_document ?? lt.requiresDocument ?? false,
//     probation_restricted: lt.probation_restricted ?? lt.probationRestricted ?? false,
//     gender_restriction: lt.gender_restriction ?? lt.genderRestriction ?? null,
//   }));
// }

// // ── GET single leave type by ID ───────────────────────
// // GET /leave-types/:id
// export async function getLeaveTypeById(id, token) {
//   const data = await safeFetch(`${BASE_URL}/api/leave-types/${id}`, {
//     headers: getHeaders(token),
//   });
//   return {
//     ...data,
//     unit_type:         data.unit_type ?? data.unitType ?? "DAY",
//     is_active:         data.is_active ?? data.isActive ?? true,
//     requires_document: data.requires_document ?? data.requiresDocument ?? false,
//   };
// }

// // ── GET leave balances by employee ───────────────────
// // GET /leave-balances/employee/:employeeId
// export async function getLeaveBalances(empId, token) {
//   const data = await safeFetch(
//     `${BASE_URL}/api/leave-balances/employee/${empId}`,
//     { headers: getHeaders(token) }
//   );
//   return Array.isArray(data) ? data : data.balances ?? data.data ?? [];
// }

// // ── GET leave history by employee ────────────────────
// // GET /leave-requests/employee/:employeeId
// export async function getLeavesByEmployee(empId, token) {
//   const data = await safeFetch(
//     `${BASE_URL}/api/leave-requests/employee/${empId}`,
//     { headers: getHeaders(token) }
//   );
//   return Array.isArray(data) ? data : data.requests ?? data.data ?? [];
// }

// // ── CREATE leave request ──────────────────────────────
// // POST /leave-requests
// export async function createLeaveRequest(payload, token) {
//   const data = await safeFetch(`${BASE_URL}/api/leave-requests`, {
//     method: "POST",
//     headers: getHeaders(token),
//     body: JSON.stringify(payload),
//   });
//   return data;
// }

// // ── CANCEL leave request ──────────────────────────────
// // PUT /leave-requests/cancel/:id
// // Backend checks leave.employee_id === employeeId for auth
// export async function cancelLeaveRequest(id, empId, token) {
//   const data = await safeFetch(`${BASE_URL}/api/leave-requests/cancel/${id}`, {
//     method: "PUT",
//     headers: getHeaders(token),
//     body: JSON.stringify({ employee_id: empId }),
//   });
//   return data;
// }

// // ── UPDATE leave request ──────────────────────────────
// // PUT /leave-requests/:id
// export async function updateLeaveRequest(id, payload, token) {
//   const data = await safeFetch(`${BASE_URL}/api/leave-requests/${id}`, {
//     method: "PUT",
//     headers: getHeaders(token),
//     body: JSON.stringify(payload),
//   });
//   return data;
// }

// // ── GET leave by ID ───────────────────────────────────
// // GET /leave-requests/:id
// export async function getLeaveById(id, token) {
//   return safeFetch(`${BASE_URL}/api/leave-requests/${id}`, {
//     headers: getHeaders(token),
//   });
// }

// // ── GET leaves by manager ─────────────────────────────
// // GET /leave-requests/manager/:managerId
// export async function getLeavesByManager(managerId, token) {
//   const data = await safeFetch(
//     `${BASE_URL}/api/leave-requests/manager/${managerId}`,
//     { headers: getHeaders(token) }
//   );
//   return Array.isArray(data) ? data : data.requests ?? data.data ?? [];
// }


// src/services/leaveApiService.js
// ─────────────────────────────────────────────────────
// Centralized API service — all leave related calls
// Base URL: http://localhost:3030/api
// ─────────────────────────────────────────────────────

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:3030/api";

function getHeaders(token) {
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

// Safe fetch helper — prevents HTML parse error on 404/500
async function safeFetch(url, options = {}) {
  const res = await fetch(url, options);
  if (!res.ok) {
    const text = await res.text();
    const msg = text.startsWith("<") // HTML error page
      ? `API error ${res.status} at ${url}`
      : text;
    throw new Error(msg);
  }
  return res.json();
}

// ── GET all leave types ───────────────────────────────
// GET /leave-types
export async function getLeaveTypes(token) {
  const data = await safeFetch(`${BASE_URL}/api/leave-types`, {
    headers: getHeaders(token),
  });
  const list = Array.isArray(data) ? data : data.leaveTypes ?? data.data ?? [];
  // Normalize field names — backend may use unit_type or unitType
  return list.map(lt => ({
    ...lt,
    id:               lt.id,
    name:             lt.name,
    unit_type:        lt.unit_type ?? lt.unitType ?? "DAY",
    is_active:        lt.is_active ?? lt.isActive ?? true,
    is_deleted:       lt.is_deleted ?? lt.isDeleted ?? false,
    requires_document: lt.requires_document ?? lt.requiresDocument ?? false,
    probation_restricted: lt.probation_restricted ?? lt.probationRestricted ?? false,
    gender_restriction: lt.gender_restriction ?? lt.genderRestriction ?? null,
  }));
}

// ── GET single leave type by ID ───────────────────────
// GET /leave-types/:id
export async function getLeaveTypeById(id, token) {
  const data = await safeFetch(`${BASE_URL}/api/leave-types/${id}`, {
    headers: getHeaders(token),
  });
  return {
    ...data,
    unit_type:         data.unit_type ?? data.unitType ?? "DAY",
    is_active:         data.is_active ?? data.isActive ?? true,
    requires_document: data.requires_document ?? data.requiresDocument ?? false,
  };
}

// ── GET leave balances by employee ───────────────────
// GET /leave-balances/employee/:employeeId
export async function getLeaveBalances(empId, token) {
  const data = await safeFetch(
    `${BASE_URL}/api/leave-balances/employee/${empId}`,
    { headers: getHeaders(token) }
  );
  return Array.isArray(data) ? data : data.balances ?? data.data ?? [];
}

// ── GET leave history by employee ────────────────────
// GET /leave-requests/employee/:employeeId
export async function getLeavesByEmployee(empId, token) {
  const data = await safeFetch(
    `${BASE_URL}/api/leave-requests/employee/${empId}`,
    { headers: getHeaders(token) }
  );
  return Array.isArray(data) ? data : data.requests ?? data.data ?? [];
}

// ── CREATE leave request ──────────────────────────────
// POST /leave-requests
export async function createLeaveRequest(payload, token) {
  const data = await safeFetch(`${BASE_URL}/api/leave-requests`, {
    method: "POST",
    headers: getHeaders(token),
    body: JSON.stringify(payload),
  });
  return data;
}

// ── CANCEL leave request ──────────────────────────────
// PUT /leave-requests/cancel/:id
// Backend checks leave.employee_id === employeeId for auth
export async function cancelLeaveRequest(id, empId, token, reason = "") {
  const data = await safeFetch(`${BASE_URL}/api/leave-requests/cancel/${id}`, {
    method: "PUT",
    headers: getHeaders(token),
    body: JSON.stringify({
      employee_id: empId,
      employeeId: empId,
      reason,
      cancel_reason: reason,
    }),
  });
  return data;
}

// ── UPDATE leave request ──────────────────────────────
// PUT /leave-requests/:id
export async function updateLeaveRequest(id, payload, token) {
  const data = await safeFetch(`${BASE_URL}/api/leave-requests/${id}`, {
    method: "PUT",
    headers: getHeaders(token),
    body: JSON.stringify(payload),
  });
  return data;
}

// ── GET leave by ID ───────────────────────────────────
// GET /leave-requests/:id
export async function getLeaveById(id, token) {
  return safeFetch(`${BASE_URL}/api/leave-requests/${id}`, {
    headers: getHeaders(token),
  });
}

// ── GET leaves by manager ─────────────────────────────
// GET /leave-requests/manager/:managerId
export async function getLeavesByManager(managerId, token) {
  const data = await safeFetch(
    `${BASE_URL}/api/leave-requests/manager/${managerId}`,
    { headers: getHeaders(token) }
  );
  return Array.isArray(data) ? data : data.requests ?? data.data ?? [];
}

// ── GET employee by ID (fetch manager details) ────────
// GET /employees/:employeeId
export async function getEmployeeById(empId, token) {
  const data = await safeFetch(
    `${BASE_URL}/api/leave-requests/employee/${empId}/profile`,  
    { headers: getHeaders(token) }
  );
  return data;
}

// ── UPLOAD attachments ────────────────────────────────
// POST /leave-requests/:id/attachments
export async function uploadLeaveAttachments(id, files, uploadedBy, token) {
  const fd = new FormData();
  files.forEach((f) => fd.append("files", f));
  fd.append("uploadedBy", uploadedBy);

  const res = await fetch(`${BASE_URL}/api/leave-requests/${id}/attachments`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: fd,
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Attachment upload failed");
  }
  return res.json();
}

// ── GET all leave policies ────────────────────────────
// GET /leave-policies
export async function getLeavePolicies(token) {
  try {
    const data = await safeFetch(`${BASE_URL}/api/leave-policies`, {
      headers: getHeaders(token),
    });
    return Array.isArray(data) ? data : data.policies ?? data.data ?? [];
  } catch (err) {
    console.error("[leaveApiService] Failed to fetch leave policies:", err);
    return [];
  }
}

// ── HELPER: Check if a leave item is Work From Home (WFH) ────────
export function isWFH(item) {
  if (!item) return false;
  const code = (item.code || item.leave_code || item.leaveCode || "").toUpperCase();
  const name = (item.name || item.leave_type_name || item.leaveName || "").toUpperCase();
  return (
    code === "WFH" ||
    code === "WORK FROM HOME" ||
    name.includes("WFH") ||
    name.includes("WORK FROM HOME")
  );
}

// ── UTILITY: Compute dynamic leave balances ────────────────────
export function computeDynamicBalances(rawBalances, history, allLeaveTypes = [], policies = []) {
  const map = {};

  // Build active lookup sets if allLeaveTypes is provided (WFH excluded from leave balances)
  const hasTypes = Array.isArray(allLeaveTypes) && allLeaveTypes.length > 0;
  const activeTypes = hasTypes ? allLeaveTypes.filter((lt) => lt.is_active && !lt.is_deleted && !isWFH(lt)) : [];
  const activeIds = new Set(activeTypes.map((lt) => String(lt.id)));

  // Map policy allocations by leave_type_id
  const policyMap = {};
  if (Array.isArray(policies)) {
    policies.forEach((p) => {
      const key = String(p.leave_type_id ?? p.leaveTypeId);
      const days = parseFloat(p.allocated_days ?? p.allocatedDays ?? p.allocated_hours ?? p.allocatedHours ?? 0);
      if (days > 0 && (!policyMap[key] || days > policyMap[key].days)) {
        policyMap[key] = {
          days,
          cycle: p.cycle || null,
          effective_from: p.effective_from || p.effectiveFrom || null,
          effective_to: p.effective_to || p.effectiveTo || null,
        };
      }
    });
  }

  // Seed map with all active leave types
  activeTypes.forEach((lt) => {
    const policy = policyMap[String(lt.id)];
    map[lt.id] = {
      leave_type_id: lt.id,
      leave_type_name: lt.name,
      unit_type: lt.unit_type || "DAY",
      allocated: policy ? policy.days : 0,
      cycle: policy ? policy.cycle : null,
      effective_from: policy ? policy.effective_from : null,
      effective_to: policy ? policy.effective_to : null,
      used: 0,
      available: 0,
      lop: 0,
    };
  });

  // Aggregate allocations and basic info from raw DB balances
  if (Array.isArray(rawBalances)) {
    rawBalances.forEach((r) => {
      if (isWFH(r)) return; // Exclude WFH from leave balances
      const key = r.leave_type_id;
      // Skip inactive leave types if we have activeTypes list
      if (hasTypes && !activeIds.has(String(key))) {
        return;
      }

      const policy = policyMap[String(key)];
      const defaultAlloc = policy ? policy.days : 0;

      if (!map[key]) {
        map[key] = {
          leave_type_id: r.leave_type_id,
          leave_type_name: r.leave_type_name,
          unit_type: r.unit_type,
          allocated: defaultAlloc,
          cycle: policy ? policy.cycle : null,
          effective_from: policy ? policy.effective_from : null,
          effective_to: policy ? policy.effective_to : null,
          used: 0,
          available: 0,
          lop: 0,
        };
      }
      const rawAlloc = parseFloat(
        r.allocated ?? r.allocated_days ?? r.allocatedDays ?? r.available ?? r.available_days ?? r.balance ?? 0
      );

      // We only override the allocated if there's no policy enforcing it, or if it's 0.
      if (rawAlloc > 0 && !policy) {
        map[key].allocated = rawAlloc;
      } else if (map[key].allocated === 0 && defaultAlloc > 0) {
        map[key].allocated = defaultAlloc;
      }
    });
  }

  // Calculate dynamic used, available, and lop from history
  const result = Object.values(map).map((bal) => {
    const usedFromHistory = (history || [])
      .filter((h) => {
        if (isWFH(h)) return false; // WFH is not a leave and must not reduce leave balance
        if (String(h.leave_type_id) !== String(bal.leave_type_id)) return false;
        if (h.status !== "APPROVED" && h.status !== "PENDING") return false;
        
        const leaveDate = new Date(h.start_date);
        
        // Only reset for Permission leave type. If it's a Monthly cycle, only count leaves in the CURRENT month and year
        if (bal.leave_type_name === 'Permission' && bal.cycle && bal.cycle.toLowerCase() === 'monthly') {
          const now = new Date();
          if (leaveDate.getMonth() !== now.getMonth() || leaveDate.getFullYear() !== now.getFullYear()) {
            return false;
          }
        }
        
        // Filter by policy effective dates if they exist
        if (bal.effective_from) {
          const effectiveFrom = new Date(bal.effective_from);
          if (leaveDate < effectiveFrom) return false;
        }
        if (bal.effective_to) {
          const effectiveTo = new Date(bal.effective_to);
          // Set effectiveTo to end of day
          effectiveTo.setHours(23, 59, 59, 999);
          if (leaveDate > effectiveTo) return false;
        }
        
        return true;
      })
      .reduce((sum, h) => sum + parseFloat(h.total_units || 0), 0);

    const allocated = bal.allocated;
    let available = allocated - usedFromHistory;
    let lop = 0;

    if (available < 0) {
      lop = Math.abs(available);
      available = 0;
    }

    if (allocated === 0 && usedFromHistory > 0) {
      lop = usedFromHistory;
    }

    return {
      ...bal,
      used: usedFromHistory,
      available: Math.max(0, available),
      lop,
    };
  });

  // Strict filter: return ONLY active leave types when activeTypes provided
  if (hasTypes) {
    return result.filter((bal) => activeIds.has(String(bal.leave_type_id)));
  }

  return result;
}